const chromosomePattern = '(?:\\d+|X|Y)';
const bandPattern = '[pq]\\d+(?:\\.\\d+)?';
const chromosomeBandPattern = `${chromosomePattern}${bandPattern}`;
const regionSizePattern = '\\d+(?:\\.\\d+)?Mb';
const deletionDuplicationEntryPattern = `(del|dup)\\(${chromosomeBandPattern}-${bandPattern},${regionSizePattern}\\)`;
const supportedLetterPattern =
  'A-Za-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u024F\\u1E00-\\u1EFF\\u0370-\\u03FF\\u0400-\\u04FF';
const syndromeNamePattern = `[${supportedLetterPattern}0-9][${supportedLetterPattern}\\u0300-\\u036F0-9 .-]*`;

export const autosomalAneuploidiesPattern =
  '^(|NotDetected|((M|T)(1[0-9]|2[0-4]|[1-9]))(;(M|T)(1[0-9]|2[0-4]|[1-9]))*)$';

export const deletionDuplicationPattern = `^(|NotDetected|${deletionDuplicationEntryPattern}(;${deletionDuplicationEntryPattern})*)$`;

export const deletionDuplicationSyndromesPattern = `^(|NotDetected|${syndromeNamePattern},${deletionDuplicationEntryPattern}(;${syndromeNamePattern},${deletionDuplicationEntryPattern})*)$`;
